import { gql } from "@apollo/client"

export const ADD_UPDATE_SELLABLE_ITEM_STOCK_VARIANT = gql`
  mutation AddUpdateVariant(
    $parentBatchStockId: ID!
    $sellableItemId: ID!
    $sellableItemStockInput: SellableItemStockInput!
    $batchStockInput: BatchStockInput!
    $parentSellableItemStockId: ID!
  ) {
    addUpdateVarientFromBatchStock(
      parentSellableItemStockId: $parentSellableItemStockId
      parentBatchStockId: $parentBatchStockId
      sellableItemId: $sellableItemId
      sellableItemStockInput: $sellableItemStockInput
      batchStockInput: $batchStockInput
    ) {
      sellableItem {
        id
        name
      }
      sellableItemStock {
        id
        unitRate
        currentStockCount
      }
      batchStock {
        id
        codename
        totalQuantity
      }
    }
  }
`
